<template>
  <div>
    <!--  Dollar Amounts -->

    <div class="row col-md-6">
      <div v-if="show.includes('assetsUnderManagment')">
        <label> Assets Under Management (AUM)</label>
        <div class="form-group col-md-11 input-group">
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>$</span>
          </span>
          <input
            class="form-control"
            type="number"
            step="1"
            v-model="assetsUnderManagment"
            min="0"
            max="100000000000"
          />
        </div>
      </div>
      <div v-if="show.includes('minimumInvestment')">
        <label> Minimum Investment in USD</label>
        <div class="form-group col-md-11 input-group">
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>$</span>
          </span>
          <input
            class="form-control"
            type="number"
            step="1"
            v-model="minimumInvestment"
            min="0"
            max="100000000"
          />
        </div>
      </div>
      <div v-if="show.includes('maximumInvestment')">
        <label> Maximum Investment in USD</label>
        <div class="form-group col-md-11 input-group">
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>$</span>
          </span>
          <input
            class="form-control"
            v-model="maximumInvestment"
            type="number"
            step="1"
            min="0"
            max="100000000"
          />
        </div>
      </div>
      <div v-if="show.includes('avgAmountRaised')">
        <label> Average Amount Invested in USD</label>
        <p>
          <small>Average amount invested per company.</small>
        </p>
        <div class="form-group col-md-11 input-group">
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>$</span>
          </span>
          <input
            class="form-control"
            v-model="avgAmountRaised"
            type="number"
            step="1"
            min="0"
            max="100000000"
          />
        </div>
      </div>

      <!--  Counts/Number Amounts -->

      <div v-if="show.includes('numberOfInvestments')">
        <label> Number of Investments</label>
        <p>
          <small>Total number of investments provided to date.</small>
        </p>
        <div class="form-group col-md-11 input-group">
          <input
            class="form-control"
            v-model="numberOfInvestments"
            type="number"
            step="1"
            min="0"
            max="10000"
          />
        </div>
      </div>
      <!--  Tiome Periods (ASC Days -> Years) -->
      <div v-if="show.includes('timeToExitInDays')">
        <label> Time to Close Deal</label>
        <p>
          <small
            >Average amount of time taken to perform due diligence and invest in
            firm.</small
          >
        </p>
        <div class="form-group col-md-11 input-group" style="width: 120px;">
          <input
            class="form-control"
            v-model="timeToExitInDays"
            type="number"
            style="padding-right:0px;"
            step="1"
            min="0"
            max="1000"
          />
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>Days</span>
          </span>
        </div>
      </div>

      <div v-if="show.includes('timeToExitInYears')">
        <label> Time to Exit </label>
        <p>
          <small
            >How long does this provider stay involved with companies before
            looking to exit.</small
          >
        </p>
        <div class="form-group col-md-11 input-group" style="width: 120px;">
          <input
            class="form-control"
            v-model="timeToExitInYears"
            style="padding-right:0px;"
            type="number"
            step="0.01"
            min="0"
            max="100"
          />
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>Years</span>
          </span>
        </div>
      </div>
      <!--  Percentages and Rates -->
      <div v-if="show.includes('successRate')">
        <label> Success Rate</label>
        <p>
          <small
            >Number of successful investments over total number of
            investments.</small
          >
        </p>
        <div class="form-group col-md-11 input-group" style="width: 100px;">
          <input
            class="form-control"
            v-model="successRate"
            type="number"
            step="1"
            style="padding-right:0px;"
            min="0"
            max="100"
          />
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>%</span>
          </span>
        </div>
      </div>

      <div v-if="show.includes('averageIrrSought')">
        <label>Average Internal Rate of Return (IRR) Sought</label>
        <p>
          <small>Rate of return sought on investment.</small>
        </p>
        <div class="form-group col-md-11 input-group" style="width: 100px;">
          <input
            class="form-control"
            v-model="averageIrrSought"
            type="number"
            step="1"
            style="padding-right:0px;"
            min="-100"
            max="1000"
          />
          <span
            class="input-group-addon"
            style="background: white; width: 10px;"
          >
            <span>%</span>
          </span>
        </div>
      </div>
      <!--  Booleans -->

      <div v-if="show.includes('boardSeat')">
        <div style="margin-top: 10px; margin-bottom: 10px;">
          <label style="margin-right: 10px;">Board Seat</label>
          <p>
            <small
              >Does the provider take a board seat on the company it's investing
              in?</small
            >
          </p>
          <input type="radio" id="one" value="1" v-model="boardSeat" />
          <label for="one" style="margin-right: 10px;">Yes</label>
          <input type="radio" id="two" value="0" v-model="boardSeat" />
          <label for="two">No</label>
        </div>
      </div>

      <div v-if="show.includes('femaleFocus')">
        <div style="margin-top: 10px; margin-bottom: 10px;">
          <label style="margin-right: 10px;"
            >Focus on Female Entrepreneurs</label
          >
          <p>
            <small
              >Do you have a specific focus on funding women-owned
              businesses?</small
            >
          </p>
          <input type="radio" id="one" value="1" v-model="femaleFocus" />
          <label for="one" style="margin-right: 10px;">Yes</label>
          <input type="radio" id="two" value="0" v-model="femaleFocus" />
          <label for="two">No</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "./textInput.vue";

export default {
  name: "provider-page",
  components: {
    textInput: textInput
  },
  props: ["show"],
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain"
    }),
    minimumInvestment: {
      set: function(editedData) {
        this.setStatValue(1)(editedData * 100);
      },
      get: function() {
        return this.getStatValue(1) / 100;
      }
    },
    maximumInvestment: {
      set: function(editedData) {
        this.setStatValue(2)(editedData * 100);
      },
      get: function() {
        return this.getStatValue(2) / 100;
      }
    },
    numberOfInvestments: {
      set: function(editedData) {
        this.setStatValue(3)(editedData);
      },
      get: function() {
        return this.getStatValue(3);
      }
    },
    avgAmountRaised: {
      set: function(editedData) {
        this.setStatValue(4)(editedData * 100);
      },
      get: function() {
        return this.getStatValue(4) / 100;
      }
    },
    successRate: {
      set: function(editedData) {
        this.setStatValue(5)(editedData);
      },
      get: function() {
        return this.getStatValue(5);
      }
    },
    timeToExitInDays: {
      set: function(editedData) {
        this.setStatValue(11)(editedData);
      },
      get: function() {
        return this.getStatValue(11);
      }
    },
    timeToExitInYears: {
      set: function(editedData) {
        this.setStatValue(12)(editedData);
      },
      get: function() {
        return this.getStatValue(12);
      }
    },
    averageIrrSought: {
      set: function(editedData) {
        this.setStatValue(13)(editedData);
      },
      get: function() {
        return this.getStatValue(13);
      }
    },
    boardSeat: {
      set: function(editedData) {
        var value = editedData == "1" ? 1 : 0;
        this.setStatValue(14)(value);
      },
      get: function() {
        return this.getStatValue(14) == 1 ? "1" : "0";
      }
    },
    femaleFocus: {
      set: function(editedData) {
        var value = editedData == "1" ? 1 : 0;
        this.setStatValue(15)(value);
      },
      get: function() {
        return this.getStatValue(15) == 1 ? "1" : "0";
      }
    },
    assetsUnderManagment: {
      set: function(editedData) {
        this.setStatValue(16)(editedData * 100);
      },
      get: function() {
        return this.getStatValue(16) / 100;
      }
    }
  },
  methods: {
    ...mapMutations({
      deleteProperty: "deleteEditedProviderPropertyByKeyChain",
      setProperty: "setEditedProviderByKeyChain"
    }),
    getStatValue: function(i) {
      var value = this.getProperty([
        "provider_stats",
        {
          filterField: "stat_id",
          filterValue: i
        },
        "value"
      ]);
      if (value) {
        return value;
      } else {
        return "";
      }
    },
    setStatValue: function(i) {
      var self = this;
      var f = function(editedData) {
        var value = self.getProperty([
          "provider_stats",
          {
            filterField: "stat_id",
            filterValue: i
          }
        ]);
        if (value) {
          // edit
          var index = self.getProperty(["provider_stats"]).findIndex(stat => {
            return stat.stat_id == value.stat_id;
          });
          self.setProperty({
            data: editedData,
            keyChain: ["provider_stats", index, "value"]
          });
        } else {
          if (editedData != "") {
            // create
            var vals = self.getProperty(["provider_stats"]);
            var stat = _createStatObj(i);
            stat.value = editedData;
            vals.push(stat);
            self.setProperty({
              data: vals,
              keyChain: ["provider_stats"]
            });
          }
        }
      };
      return f;
    }
  }
};

function _createStatObj(i) {
  return {
    stat: {
      id: i
    },
    stat_id: i,
    value: undefined
  };
}
</script>



// WEBPACK FOOTER //
// src/elements/stats.vue